import React from 'react';
import { Icon } from 'semantic-ui-react';
import './Indicator.css';
export default function Indicator(_ref) {
  var index = _ref.index,
    currentIndex = _ref.currentIndex,
    changeCurrentIndex = _ref.changeCurrentIndex;
  return /*#__PURE__*/React.createElement(Icon, {
    className: "image-indicator",
    size: "small",
    name: index === currentIndex ? 'circle' : 'circle outline',
    inverted: true,
    onClick: function onClick() {
      return changeCurrentIndex(index);
    }
  });
}